import { getDateComparator } from 'utils/dates'

import { IFilterDef } from 'components/AgGrid/types'

import {
  DateMenuOptions,
  //FilterSearchBar,
  NumberFilter,
  NumberFilterProps,
  SearchFilter,
  SearchFilterProps,
  SetFilter,
  SetFilterProps,
} from './FilterOptions'
import {
  AgGridFilterType,
  DateFilter,
  FilterOptionProps,
  OptionProps,
} from './agGridFilters.types'

export const getDateFilterOptions = (
  props: FilterOptionProps & {
    value: DateFilter
    onRemoveFilter: (name: string) => void
  },
): OptionProps[] => [
  {
    content: <DateMenuOptions {...props} />,
  },
]

export const getTextFilterOptions = (
  props: SearchFilterProps,
): OptionProps[] => [{ content: <SearchFilter {...props} /> }]

export const getNumberFilterOptions = (
  props: NumberFilterProps,
): OptionProps[] => [{ content: <NumberFilter {...props} /> }]

export const getSetFilterOptions = ({
  name,
  options,
  searchText = '',
  // eslint-disable-next-line unused-imports/no-unused-vars
  setSearchText,
  ...props
}: Omit<SetFilterProps, 'option'> & {
  options: string[]
  searchText?: string
  setSearchText: (newSearchText: string) => void
}): OptionProps[] => {
  // Commented code not working but potentially this is a feature
  // product may add as an enhancement
  // const result = []

  // if (options.length > 10) {
  //   result.push({
  //     content: (
  //       <FilterSearchBar
  //         placeholder={`Search ${name}`}
  //         setSearchText={setSearchText}
  //       />
  //     ),
  //   })
  // }

  return [
    //...result,
    ...options
      .filter((option) =>
        option.toLowerCase().includes(searchText.toLowerCase()),
      )
      .map((option) => ({
        content: <SetFilter name={name} option={option} {...props} />,
      })),
  ]
}

export const dateRangeComparator = (
  filter: Date,
  { start, end }: { start: Date; end: Date },
): number => {
  if (filter < start) return 1
  if (filter > end) return -1
  return 0
}

export const getFilterConfig = (
  type: AgGridFilterType,
  options?: { isRange?: boolean },
): IFilterDef => {
  const filterDef: IFilterDef = {
    filter: '',
    filterParams: {
      suppressAndOrCondition: true,
    },
  }

  switch (type) {
    case AgGridFilterType.Date:
      filterDef.filter = 'agDateColumnFilter'
      filterDef.filterParams.filterOptions = ['equals', 'inRange']
      if (options?.isRange) {
        filterDef.filterParams.inRangeInclusive = true
        filterDef.filterParams.comparator = getDateComparator
      }
      break
    case AgGridFilterType.Text:
      filterDef.filter = 'agTextColumnFilter'
      filterDef.filterParams.filterOptions = ['contains']
      break
    case AgGridFilterType.Number:
      filterDef.filter = 'agNumberColumnFilter'
      filterDef.filterParams.filterOptions = ['inRange']
      filterDef.filterParams.inRangeInclusive = true
      break
  }

  return filterDef
}
